import React from "react";
import { Button, Form, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Pagination from "react-js-pagination";
// _includes
import { common } from "_helpers";
import { apiServices } from "_api";

export default class TopLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "process",
      isLoading: false,
      isFilter: false,
      column: 9,
      paging: {
        pageSize: 10,
        pageIndex: 1,
        recordCount: 0,
      },
      data: {
        RecordsCount: 0,
        result: [],
      },
    };
  }

  componentDidMount = async () => {
    this.loadData();
  };

  loadData = () => {
    const { paging } = this.state;
    var data = {
      url: "REPORT_LOCATION_TOP_LOCATION_GET_TABLE",
      query:
        "?PageSize=" + paging.pageSize + "&PageIndex=" + (paging.pageIndex - 1),
    };

    apiServices.call(
      data,
      (response) => {
        if (response.status === 200) {
          response = response.data;
          // add index
          response.Data.map((item, key) => {
            item.serial =
              paging.pageIndex > 1
                ? (paging.pageIndex - 1) * paging.pageSize + ++key
                : ++key;
          });
          // set data
          this.setState({
            status: "success",
            isLoading: false,
            data: {
              RecordsCount: response.RecordsCount,
              result: response.Data,
            },
          });
        }
      },
      (error) => {
        this.setState({
          status: "error",
          isLoading: false,
          data: {
            RecordsCount: 0,
            result: [],
          },
        });
      },
      (final) => { }
    );
  };

  // events
  handlePageChange(pageNumber) {
    const { paging } = this.state;
    if (paging.pageIndex != pageNumber) {
      paging.pageIndex = pageNumber;
      this.setState(
        {
          paging,
          isLoading: true,
        },
        () => {
          this.loadData();
        }
      );
    }
  }

  handleRefresh() {
    this.setState(
      {
        isLoading: true,
        isFilter: false,
        paging: {
          pageSize: 10,
          pageIndex: 1,
          recordCount: 0,
        },
        filter: {},
      },
      () => {
        this.loadData();
      }
    );
  }

  render() {
    const { status, column, data, paging, isLoading } = this.state;

    return (
      <div className="contentBox">
        <div className="poTable">
          <div className="d-flex">
            <div className="mr-auto p-2">
              <span className="potableHeadTitle"> Top Locations </span>
            </div>
            <div className="p-2">
              <div className="d-flex">
                <div className="poTableIcon">
                  <img
                    src={common.appIcon("RefreshIcon")}
                    className="poc-cp"
                    alt="Refresh"
                    onClick={() => this.handleRefresh()}
                  />
                </div>
              </div>
            </div>
          </div>

          {isLoading && (
            <div className="d-flex justify-content-center">
              <span className="poTableFetcher">
                fetching data please wait...
              </span>
            </div>
          )}

          <div className={isLoading ? "poTableOnLoad" : ""}>
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Location Name</th>
                  <th>Location Code</th>
                  <th>Location Type</th>
                  <th>Description</th>
                  <th>Country</th>
                  <th>Province</th>
                  <th>Concept</th>
                  <th>Visit Count</th>
                </tr>
              </thead>
              <tbody>
                {status == "process" ? (
                  <tr className="poTableMsg">
                    <td colSpan={column}>Loading data please wait...</td>
                  </tr>
                ) : status == "error" ? (
                  <tr className="poTableMsg">
                    <td colSpan={column}>
                      There was an error while fetching record.
                    </td>
                  </tr>
                ) : data.RecordsCount == 0 ? (
                  <tr className="poTableMsg">
                    <td colSpan={column}>Sorry no record found.</td>
                  </tr>
                ) : data.result.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item.serial}</td>
                      <td>{item.LocationName}</td>
                      <td>{item.LocationCode}</td>
                      <td>{item.LocationType}</td>
                      <td>{(item.Description ? item.Description : "-")}</td>
                      <td>{item.Country}</td>
                      <td>{item.Province}</td>
                      <td>{item.Concept}</td>
                      <td>{item.VisitCount}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {data.RecordsCount > 0 && (
              <div className="d-flex">
                <div className="mr-auto p-2">
                  Total Records: {data.RecordsCount}
                </div>
                <div className="p-2">
                  <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={paging.pageIndex}
                    itemsCountPerPage={paging.pageSize}
                    totalItemsCount={data.RecordsCount}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
